module.exports = __webpack_public_path__ + "img/location.6e2e41d6.svg";